module.exports = __webpack_public_path__ + "static/img/hash_logo.f420ed9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hash_logo.png
// module id = 0RXe
// module chunks = 1